<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Controle de números
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Números (destinatários) que receberam mensagens. Baseado nas últimas mensagens enviadas registradas no sistema.
        </p>
      </div>
    </div>

    <div class="mt-3">
      <button type="button" class="btn btn-outline-primary" (click)="carregarNumeros()">
        <i class="fa fa-refresh mr-1"></i>Atualizar
      </button>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="numeros.length > 0">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th>Número / Destinatário</th>
        <th>Mensagens enviadas (amostra)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let n of numerosPaginados">
        <td class="pl-3 pr-3 align-middle">{{ n.destinatario }}</td>
        <td class="align-middle">{{ n.totalMensagens }}</td>
      </tr>
    </tbody>
  </table>

  <div class="form-row" *ngIf="total > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
        Exibindo {{ startItem }} a {{ endItem }} de {{ total }} itens
        <span class="text-muted ml-2">(amostra: até 100 últimas mensagens)</span>
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
          class="ml-auto pagination-square"
          style="margin-top: 10px; margin-right: 10px"
          *ngIf="total > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="3"
          [rotate]="true"
          [boundaryLinks]="true"
          size="sm"
          [collectionSize]="total"
          (pageChange)="onPageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="numeros.length === 0">
  <div class="card-body">
    <div class="text-center py-4">
      <h5 class="mt-0">Nenhum número encontrado</h5>
      <p class="text-muted">Não há mensagens enviadas registradas ou os dados ainda não foram carregados.</p>
      <button type="button" class="btn btn-primary" (click)="carregarNumeros()"><i class="fa fa-refresh mr-1"></i>Atualizar</button>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
